import { ConsentCheckbox } from '../../comps/ConsentCheckbox'
import { OtpTextInput } from '../../comps/OtpTextInput'
import { testProps } from '../../util/util'
import { otp } from '../../util/validations'

export const otpForm = (value: string, setFieldValue: any): any => [
  {
    formItems: [
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        validationSchema: otp,
        maxLength: 6,
        value: value,
        setFieldValue: (_data: any, val: any) => setFieldValue(val),
      },

      {
        fieldName: 'consentCheckbox',
        ComponentName: ConsentCheckbox,
        ...testProps('consent-checkbox-terms-condition'),
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
